<template>
  <ul class="Post-Infonoise-Signals-List">
    <li class="Post-Infonoise-Signals-List__item" :class="get_classModify(signal.price_change)" v-for="signal in props.signals">
      <span class="Post-Infonoise-Signals-List__value">{{ signal.symbol }}</span>
      <span class="Post-Infonoise-Signals-List__value">{{ formatNumber(signal.start_price) }}</span>
      <ArrowThinLongIcon class="Post-Infonoise-Signals-List__arrow" />
      <span class="Post-Infonoise-Signals-List__value">{{ formatNumber(signal.current_price) }}</span>
      <span class="Post-Infonoise-Signals-List__percent">{{ signal.price_change }}</span>
    </li>
  </ul>
</template>

<script setup>
  import { Props } from './scripts/props';
  import ArrowThinLongIcon from '@svg/ArrowThinLongIcon.vue';
  //-------------------------------
  const props = defineProps(Props());
  //-------------------------------
  const get_classModify = (value) => {
    const numValue = parseFloat(value)
    return numValue < 0 ? 'Post-Infonoise-Signals-List__item--red' : 'Post-Infonoise-Signals-List__item--green';
  }
  //-------------------------------
  const formatNumber = (value) => {
    const cleaned = String(value).replace(/[^\d.-]/g, '');
    const num = Number(cleaned);

    if (isNaN(num)) return value;

    return num.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 8,
    }).replace(/(\.\d*?[1-9])0+$/g, '$1').replace(/\.0+$/, '');
  };
  </script>

<style lang="scss">
  @import "./styles/styles.scss";
</style>